import actionTypes from "../actionTypes/log";

export const updateLog = (payload) => ({
  payload,
  type: actionTypes.UPDATE_LOG,
});
